import {NgClass}                            from '@angular/common';
import {booleanAttribute, Component, input} from '@angular/core';
import {IconName}                           from '@fortawesome/fontawesome-common-types';
import {TableRowWrapperComponent}           from '../../../../../comps/table/table-row-wrapper/table-row-wrapper.component';
import {TableRow}                           from '../../../../../comps/table/table-wrapper/table-wrapper.component';
import {PanelMenuConfRowIntf}               from '../menu-crud-panel-top/menu-crud-tile/menu-crud-tile.component';
import {MenuCrudPanelWrapperBase}           from '../menu-crud-panel-wrapper-base';


export interface PanelBtnIntf {
	icon: IconName;
	uuid: string;
	func: () => void;
	text?: string;
}

@Component({
			   selector   : 'app-menu-crud-panel-bot',
			   imports: [
				   TableRowWrapperComponent,
				   NgClass
			   ],
			   templateUrl: './menu-crud-panel-bot.component.html',
			   styleUrl   : './menu-crud-panel-bot.component.css'
		   })
export class MenuCrudPanelBotComponent extends MenuCrudPanelWrapperBase {
	public rows = input<TableRow[]>();
	public conf = input<PanelMenuConfRowIntf[]>()
	public btns = input<PanelBtnIntf[]>()

	public toggle = input(false, {transform: booleanAttribute})

}